import { createSelector } from 'reselect';
//@ts-expect-error still in JS
import { isFooterId, isWebversionId } from 'EmailEditorUI/utils/moduleUtils';
import { getSelectedElement } from 'EmailEditorUI/redux/selectors/ModuleSelectors';
import { getIsEmailTemplate } from 'EmailEditorUI/redux/selectors/emailCategoriesSelectors';
export const getCanUpdateAiFlags = createSelector([getSelectedElement, getIsEmailTemplate], (selectedElement, isEmailTemplate) => {
  const module_id = selectedElement === null || selectedElement === void 0 ? void 0 : selectedElement.get('module_id');
  const isWebVersionModule = isWebversionId(module_id);
  const isFooterModule = isFooterId(module_id);
  // We don't want to flag this type of content
  const isFooterOrWebVersion = isWebVersionModule || isFooterModule;
  return !isEmailTemplate && !isFooterOrWebVersion;
});